import axios from "axios";
const baseURL = "http://154.61.173.123:7000/auth";

const loginApi = async (credentials) => {
  const response = await fetch(baseURL + "/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Login failed");
  }

  return await response.json();
};

const forgotPasswordApi = async (email) => {
  const response = await fetch(baseURL + "/otpsend", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to send reset link");
  }

  return await response.json();
};

//const verifyEmailApi = async ({ email, verification_code }) => {
// try {
//   const response = await fetch(baseURL + "/verifyotp", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ email, verification_code }),
//   });
//   if (!response.ok) {
//     const data = await response.json();
//     console.error("Error Response from Backend:", data);
//     throw new Error(data.message || "Failed to verify OTP");
//   }
//   const data = await response.json();
//   console.log("Success Response from Backend:", data);
//   return data;
// } catch (err) {
//   console.error("Network or Server Error:", err);
//   throw err;
// }
//};

const verifyEmailApi = async ({ email, verification_code }) => {
  try {
    const response = await axios.post(baseURL + "/verifyotp", {
      email,
      verification_code,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

// const resetPasswordApi = async ({ email, verification_code }) => {
//   const response = await axios.post(baseURL + "/verifyotp", {
//     email,
//     verification_code,
//   });
//   return response.data;
// };

export { loginApi, forgotPasswordApi, verifyEmailApi };
